<div class="orders-container">
  <p-toast></p-toast>
  
  <div class="orders-header">
    <button type="button" class="back-button" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      <span>Back</span>
    </button>
    <h1 class="page-title">Order History</h1>
  </div>

  @if (isLoading()) {
    <div class="loading-container">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      <p class="loading-text">Loading orders...</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <div class="error-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <h2 class="error-title">Error Loading Orders</h2>
      <p class="error-message">{{ error() }}</p>
      <button type="button" class="retry-button" (click)="loadOrders(1)">
        <i class="pi pi-refresh"></i>
        <span>Retry</span>
      </button>
    </div>
  } @else if (orders().length === 0) {
    <div class="empty-container">
      <div class="empty-icon">
        <i class="pi pi-shopping-bag"></i>
      </div>
      <h2 class="empty-title">No Orders Yet</h2>
      <p class="empty-message">You haven't placed any orders yet. Start shopping to see your order history here.</p>
    </div>
  } @else {
    <div class="orders-content">
      <div class="orders-summary">
        <p class="summary-text">Showing {{ orders().length }} of {{ totalCount() }} orders</p>
      </div>

      <div class="orders-list">
        @for (order of orders(); track order.id) {
          <div class="order-card">
            <div class="order-header">
              <div class="order-info">
                <h3 class="order-id">Order #{{ order.id.substring(0, 8).toUpperCase() }}</h3>
                <p class="order-date">{{ formatDate(order.dateCreated) }}</p>
              </div>
              <div class="order-status-wrapper">
                <span class="order-status" [class]="getOrderStatusClass(order.orderStatus)">
                  {{ getOrderStatusText(order.orderStatus) }}
                </span>
              </div>
            </div>

            <div class="order-details">
              <div class="detail-row">
                <span class="detail-label">Items:</span>
                <span class="detail-value">{{ order.totalProducts }} item{{ order.totalProducts !== 1 ? 's' : '' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Total Amount:</span>
                <span class="detail-value amount">{{ formatPrice(order.totalAmount) }}</span>
              </div>
              @if (order.transactionReference) {
                <div class="detail-row">
                  <span class="detail-label">Transaction Ref:</span>
                  <span class="detail-value ref">{{ order.transactionReference }}</span>
                </div>
              }
              @if (order.isAvailableForDelivery && order.address) {
                <div class="detail-row">
                  <span class="detail-label">Delivery Address:</span>
                  <span class="detail-value">{{ order.address }}</span>
                </div>
              } @else if (!order.isAvailableForDelivery && order.pickupLocationName) {
                <div class="detail-row">
                  <span class="detail-label">Pickup Location:</span>
                  <span class="detail-value">{{ order.pickupLocationName }}</span>
                </div>
              } @else if (!order.isAvailableForDelivery && order.pickUpLocation) {
                <div class="detail-row">
                  <span class="detail-label">Pickup Location:</span>
                  <span class="detail-value">Location ID: {{ order.pickUpLocation.substring(0, 8) }}</span>
                </div>
              }
            </div>

            <div class="order-products">
              <h4 class="products-title">Products:</h4>
              <ul class="products-list">
                @for (product of order.products; track product.productId) {
                  <li class="product-item">
                    <span class="product-quantity">{{ product.quantity }}x</span>
                    <span class="product-name">{{ product.productName || ('Product ID: ' + product.productId.substring(0, 8)) }}</span>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      </div>

      @if (totalPages() > 1) {
        <div class="pagination">
          <button 
            type="button" 
            class="pagination-btn" 
            [disabled]="currentPage() === 1"
            (click)="previousPage()">
            <i class="pi pi-chevron-left"></i>
            <span>Previous</span>
          </button>
          
          <div class="page-numbers">
            @for (page of getPageNumbers(); track page) {
              <button 
                type="button"
                class="page-number"
                [class.active]="currentPage() === page"
                (click)="goToPage(page)">
                {{ page }}
              </button>
            }
          </div>

          <button 
            type="button" 
            class="pagination-btn"
            [disabled]="currentPage() === totalPages()"
            (click)="nextPage()">
            <span>Next</span>
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      }
    </div>
  }
</div>
